import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline, Box } from '@mui/material';
import Navbar from './components/Navbar/Navbar';
import Home from './pages/Home';
import Nosotros from './pages/Nosotros';
import Contacto from './pages/Contacto';
import AI from './pages/AI';
import Comercial from './pages/Comercial';
import Film from './pages/Film';
import Footer from './components/Footer/Footer';
import CustomCursor from './components/CustomCursor/CustomCursor';
import './styles/fonts.css';
import { LanguageProvider } from './context/LanguageContext';

// Create a custom theme
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#ffffff',
    },
    background: {
      default: '#000000',
      paper: '#3C3C3C',
    },
  },
  typography: {
    fontFamily: '"Delight", "Helvetica Neue", Arial, sans-serif',
    h1: {
      fontFamily: 'Delight',
    },
    h2: {
      fontFamily: 'Delight',
    },
    h3: {
      fontFamily: 'Delight',
    },
    h4: {
      fontFamily: 'Delight',
    },
    h5: {
      fontFamily: 'Delight',
    },
    h6: {
      fontFamily: 'Delight',
    },

    
  },
});

const catalogRoutes = new Set(['/', '/film', '/ai']);

const AppLayout = () => {
  const location = useLocation();
  const showGlobalFooter = !catalogRoutes.has(location.pathname);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <CustomCursor />
      <Navbar />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/film" element={<Film />} />
          <Route path="/comercial/:commercialName" element={<Comercial />} />
          <Route path="/ai" element={<AI />} />
          <Route path="/contacto" element={<Contacto />} />
        </Routes>
      </Box>
      {showGlobalFooter && <Footer />}
    </Box>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LanguageProvider>
        <Router>
          <AppLayout />
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App; 
